import { ROUTES } from '@/constants/app';
import { Route } from 'react-router-dom';
import { AuthLandingLayout } from './components/AuthLandingLayout';
import { PublicRoute } from './components/PublicRoute';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';

export const authRoutes = (
  <Route element={<AuthLandingLayout />}>
    <Route
      path={ROUTES.AUTH.LOGIN}
      element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      }
    />
    <Route
      path={ROUTES.AUTH.REGISTER}
      element={
        <PublicRoute>
          <RegisterPage />
        </PublicRoute>
      }
    />
    <Route
      path={ROUTES.AUTH.FORGOT_PASSWORD}
      element={
        <PublicRoute>
          <ForgotPasswordPage />
        </PublicRoute>
      }
    />
    <Route
      path={ROUTES.AUTH.RESET_PASSWORD}
      element={
        <PublicRoute>
          <ResetPasswordPage />
        </PublicRoute>
      }
    />
  </Route>
);
